<template>
  <div class="min-h-screen bg-gray-50 flex flex-col justify-between">
    <div>
      <Nav />

      <div class="max-w-xl mx-auto my-10 px-4">
        <div class="bg-white shadow-md rounded-lg overflow-hidden border border-gray-200 p-6 md:p-8">
          <img src="/amazon-items-image.webp" alt="Amazon Items" class="w-full object-cover max-h-48 rounded-md shadow-sm mb-6" />

          <h1 class="text-center text-2xl font-bold text-gray-800 mb-6 font-serif">
            Add Your Products Here
          </h1>

          <div class="space-y-6">
            <div class="text-center">
              <label class="block text-lg font-serif text-gray-700 mb-2">Select The Type Of Products:</label>
              <select
                class="w-full md:w-3/4 h-12 px-3 font-serif text-lg focus:outline-none focus:ring-2 focus:ring-green-400 rounded-md border border-gray-300 bg-green-50 focus:bg-white transition"
                v-model="model.items.type_id"
              >
                <option
                  v-for="type in types"
                  :key="type.id"
                  :value="type.id"
                >
                  {{ type.name }}
                </option>
              </select>
            </div>

            <div class="text-center font-serif">
              <label class="block text-lg text-gray-700 mb-2">Enter Product Name:</label>
              <input
                type="text"
                placeholder="Enter name of product"
                class="w-full md:w-3/4 h-12 px-3 placeholder:text-gray-400 focus:outline-none focus:ring-2 focus:ring-green-400 rounded-md border border-gray-300 bg-green-50 focus:bg-white transition"
                v-model="model.items.name"
              />
            </div>

            <div class="text-center pt-4">
              <button
                :disabled="isLoading"
                class="bg-yellow-400 hover:bg-yellow-500 disabled:opacity-50 text-gray-900 font-bold px-12 py-3 rounded-full shadow-sm text-lg font-serif transition-all duration-150 flex items-center justify-center gap-2 mx-auto"
                @click="postProduct"
              >
                <span v-if="isLoading" class="animate-spin inline-block w-4 h-4 border-2 border-current border-t-transparent rounded-full"></span>
                <span>{{ isLoading ? 'Processing...' : 'Next' }}</span>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { useEcommerceStore } from "@/stores/Ecommerce";
import axios from "axios";
import { useRouter } from "vue-router";
import Nav from "@/components/Nav.vue";

export default {
  components: {
    Nav,
  },
  data() {
    return {
      types: [],
      isLoading: false,
      model: {
        items: {
          name: "",
          user_id: null,
          type_id: null,
        },
      },
    };
  },

  mounted() {
    this.fetchType();
    this.fetchItem();
    this.model.items.user_id = localStorage.getItem("userID");
    const EcommerceStore = useEcommerceStore()
    const router = useRouter();
    EcommerceStore.verifyLogin(router)
  },
  methods: {
    async fetchType() {
      try {
        const response = await axios.get("https://ecommerce-api.kalkidan.net/api/type");
        this.types = response.data.type;
      } catch (err) {
        console.log(err);
      }
    },
    async fetchItem() {
      const response = await axios.get("https://ecommerce-api.kalkidan.net/api/item");
    },
    async postProduct() {
      if (this.isLoading) return;
      this.isLoading = true;
      const formData = new FormData();
      formData.append("name", this.model.items.name);
      formData.append("user_id", this.model.items.user_id);
      formData.append("type_id", this.model.items.type_id);
      try {
        const res = await axios.post(
          "https://ecommerce-api.kalkidan.net/api/item",
          formData,
          {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          }
        );
        const itemID = res.data.item.id;
        localStorage.setItem("item_id", itemID);
        this.$router.push("/ProductDetails");
      } catch (error) {
        console.error("Error:", error.message);
        alert("Failed to save product. Please check connection and try again.");
      } finally {
        this.isLoading = false;
      }
    },
  },
};
</script>

<style scoped>
</style>
